<template>
  <b-form @submit.prevent>
    <!-- <ol class="mb-2 breadcrumb">
      <li class="breadcrumb-item"><a href="">پذیرش</a></li>
      <li class="breadcrumb-item">ثبت مراجعه</li>
    </ol> -->
    <section class="white-section mb-2">
      <b-row>
<!--        <b-col xl="3" lg="2" md="4" sm="6">-->
<!--          <b-form-group-->
<!--              :label="$t('permissions.parent')"-->
<!--              label-for="permission-parent"-->
<!--          >-->
<!--            <b-form-select-->
<!--                text-field="title"-->
<!--                value-field="_id"-->
<!--                v-model="permissionToEdit.parentId"-->
<!--                id="permission-parent"-->
<!--            >-->
<!--              <b-form-select-option-->
<!--                  v-for="p in permissions"-->
<!--                  :key="p._id"-->
<!--                  :value="p._id"-->
<!--              >-->
<!--                <div class="d-flex justify-content-between">-->
<!--                  <span>{{-->
<!--                      p.title-->
<!--                    }}</span>-->
<!--                </div>-->
<!--              </b-form-select-option>-->
<!--            </b-form-select>-->
<!--          </b-form-group>-->
<!--        </b-col>-->
        <b-col xl="3" lg="2" md="4" sm="6">
          <b-form-group
              :invalid-feedback="
              invalidFeedbackTitle
                ? $t(`validation.${invalidFeedbackTitle}`, {
                    field: $t('permissions.title'),
                  })
                : ''
            "
              :state="
              $v.permissionToEdit.title.$dirty
                ? !$v.permissionToEdit.title.$invalid
                : null
            "
              :label="$t('permissions.title')"
              label-for="permission-title"
          >
            <b-form-input
                v-model="permissionToEdit.title"
                type="text"
                class="d-inline-block"
                :state="
              $v.permissionToEdit.title.$dirty
                ? !$v.permissionToEdit.title.$invalid
                : null
            "
                id="permission-title"
            />
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="2" md="4" sm="6">
          <b-form-group
              :invalid-feedback="
              invalidFeedbackKey
                ? $t(`validation.${invalidFeedbackKey}`, {
                    field: $t('permissions.key'),
                  })
                : ''
            "
              :state="
              $v.permissionToEdit.key.$dirty
                ? !$v.permissionToEdit.key.$invalid
                : null
            "
              :label="$t('permissions.key')"
              label-for="permission-key"
          >
            <b-form-input
                v-model="permissionToEdit.key"
                type="text"
                class="d-inline-block"
                :state="
              $v.permissionToEdit.key.$dirty
                ? !$v.permissionToEdit.key.$invalid
                : null
            "
                id="permission-key"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12" class="text-right">
          <b-button
              size=""
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="info"
              @click="createAPermission"
          >
            {{ $t("general.submit") }}
          </b-button>
        </b-col>

      </b-row>
    </section>
  </b-form>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";
import ripple from "vue-ripple-directive";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BCol,
  BRow,
  BButton
} from 'bootstrap-vue'
export default {
  created(){
    this.$store.dispatch('permissions/getAPermission', this.$route.params.permissionId).then(res => {
          this.permissionToEdit = res;
          
    this.$store.dispatch('permissions/getPermissions').then((res) => {
      this.permissions.unshift({
        title: this.$t("general.pleaseSelect"),
        _id: null,
      });
      // this.$set(this.permissionToEdit, 'parentId', this.permissions[0]._id)
      // this.permissionToEdit.parentId = this.permissions[0]
    })
    })

  },
  validations() {
    return {
      permissionToEdit: {
        title:{
          required,
        },
        key:{
          required,
        },
        // parentId:{
        //   required,
        // },
      },
    };
  },
  computed: {
    ...mapGetters({
      permissions: 'permissions/permissions'
    }),
    permissionToEdit:{
      get(){
        return this.$store.getters['permissions/permissionToEdit']
      },
      set(permissionToEdit){
        this.$store.commit('permissions/SET_PERMISSION_TO_EDIT',permissionToEdit )
      }
    },
    invalidFeedbackTitle: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.permissionToEdit.title.$dirty) return error;
        if (!this.$v.permissionToEdit.title.required) error = "required";
        return error;
      },
    },
    invalidFeedbackKey: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.permissionToEdit.key.$dirty) return error;
        if (!this.$v.permissionToEdit.key.required) error = "required";
        return error;
      },
    },
    // invalidFeedbackParent: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.$v.permissionToEdit.parentId.$dirty) return error;
    //     if (!this.$v.permissionToEdit.parentId.required) error = "required";
    //     return error;
    //   },
    // },
  },
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BCol,
    BRow,
    BButton},
  methods:{
    createAPermission(){
      this.$v.$touch();
      // console.log(this.permissionToEdit);
      if ( !this.$v.$invalid){
        let payload = {};
        payload.permission = { title: this.permissionToEdit.title,
          parentId: this.permissionToEdit.parentId,
          key: this.permissionToEdit.key};
        payload.id = this.$route.params.permissionId;
        payload = _.omitBy(payload, (v) => _.isUndefined(v) || _.isNull(v) || v === '');
        this.$store.dispatch('permissions/editPermission', payload).then((res)=>{
          this.$root.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
            // title: this.$t('toastification.success'),
            variant: 'success',
            solid: true,
          });
          this.$store.commit('permissions/RESET_PERMISSION');
          this.$router.push({name: 'managePermissions'})
        })
      }
    }
  },
  directives: {ripple}
}
</script>